<template>


  <v-fab-transition>
    <v-card
        class=""
        width="508"
        v-show="active"
        height="530"
        transparent
        flat
        elevation="20"
        color="#b01e28"
        style="margin-top:40px;margin-left:40px;"
    >
      <v-system-bar
          style="position: absolute;z-index: 2;width:100%;height:40px;background: rgba(0,0,0,0.0)"

          dark
      >
        <h4 :style="{'color':(stage<2 || stage===7)?'#eeeeee':'white'}" style="width:100%;text-align: center;font-weight: bold;">Sponsrat meddelande från 24.se</h4>
      </v-system-bar>
      <v-img

          style="position: absolute; top: 0px; left: 0px; width: 511px; margin-left: -2px; border-top-left-radius: 4px;border-top-right-radius: 4px;max-width:200% !important;z-index: 0;opacity: 0.2;"
          :src="'https://hihat.io/api/images/24_bg.png'"
      >

      </v-img>


      <v-img
          v-if="stage===1"

          style="position: absolute; top: 10px; left: 38px; width: 441px; z-index: 1; height: 120px;"

          :src="'https://hihat.io/api/images/24_logo3.png'"
      >
      </v-img>
      <v-slide-y-transition>
        <v-card  style="height:70%;width:85%;top:18%;left:7.5%;position: absolute;border-radius: 10px;-webkit-box-shadow: 0px 0px 28px 13px rgb(0 0 0 / 25%); box-shadow: 0px 0px 28px 13px rgb(0 0 0 / 25%)" v-show="stage===0">

          <v-img
              class="mx-auto"
              style="width:256px;margin-top:20px;"

              :src="'https://hihat.io/api/images/24_logo_3.png'"
          >
          </v-img>

          <v-card-text>
            <v-btn text style="text-transform: none;font-size:16px;" block class="mx-auto" dark color="#b01e28">Få 50 KR rabatt med {{streamer_name}} kod</v-btn>

            <v-btn style="text-transform: none;letter-spacing: 8px;" block class="mx-auto" dark color="#b01e28">

              <span :class="glow_index===index?'glow_letter':''" v-for="(letter,index) in code" :key="index" class="promo_code">{{ letter }}</span>


            </v-btn>
            <v-btn text style="text-transform: none;" block class="mx-auto" dark color="#b01e28">vid köp över 150kr</v-btn>


          </v-card-text>
        </v-card>
      </v-slide-y-transition>



      <v-slide-y-transition>
        <v-card  style="height:70%;width:85%;top:15%;left:7.5%;position: absolute;border-radius: 10px;-webkit-box-shadow: 0px 0px 28px 13px rgb(0 0 0 / 25%); box-shadow: 0px 0px 28px 13px rgb(0 0 0 / 25%)" v-show="stage===1">



          <v-card-text>

          </v-card-text>
          <div v-show="stage===1"  id="add_names" style="width:100%;height:100%;background: transparent;position: absolute;top:0;left:0;z-index: 2;">

          </div>
          <v-img style="height:256px;width:256px;" class="mx-auto" :src="to_show.image" eager>

          </v-img>
          <div style="height:85px;width:85px;background:#b01e28;border-radius: 50%;transform:rotate(-30deg);left:40px;position:absolute;top:50px;box-shadow:4px 6px 3px 0px #00000029;">
            <h1 style="color: white; position: absolute; top: 16px;white-space: nowrap; left: 9px;">?? kr</h1>
          </div>
          <v-card color="transparent" flat>
            <v-card-title style="font-size:18px;text-align: right;width:100%;" class="py-0">
              {{to_show.name}}
            </v-card-title>
            <v-card-text style="font-size:16px;">
              {{to_show.desc}}

            </v-card-text>

          </v-card>
          <v-card-actions style="margin-top:10px;">
            <v-btn text large style="text-transform: none;font-size:30px;border-radius:8px;" v-if="guess_text" block class="mx-auto" dark >GISSA PRISET!</v-btn>
            <v-btn text large v-else block class="mx-auto" dark  style="text-transform: none;border-radius:8px;font-size:20px;">t.ex:  <i style="margin-right:4px;margin-left:4px;background: white;color:#b01e28;border-radius: 4px;font-size:26px;padding:4px;">!{{ random_guess }}</i>  i chatten</v-btn>

          </v-card-actions>
        </v-card>
      </v-slide-y-transition>
      <v-slide-y-transition>
        <v-card  style="height:70%;width:85%;top:15%;left:7.5%;position: absolute;border-radius: 10px;-webkit-box-shadow: 0px 0px 28px 13px rgb(0 0 0 / 25%); box-shadow: 0px 0px 28px 13px rgb(0 0 0 / 25%)" v-show="stage===2">



          <v-card-text>

          </v-card-text>

          <v-img style="height:256px;width:256px;" class="mx-auto" :src="to_show.image" eager>

          </v-img>
          <div style="height:85px;width:85px;background:#b01e28;border-radius: 50%;transform:rotate(-30deg);left:40px;position:absolute;top:50px;box-shadow:4px 6px 3px 0px #00000029;">
            <h1 style="color: white; position: absolute; top: 16px;white-space: nowrap; left: 9px;">{{to_show.price}}:-</h1>
          </div>
          <v-card color="transparent" flat>
            <v-card-title style="font-size:18px;text-align: right;width:100%;" class="py-0">
              {{to_show.name}}
            </v-card-title>
            <v-card-text style="font-size:16px;">
              {{to_show.desc}}

            </v-card-text>

          </v-card>
          <v-card-actions style="margin-top:10px;">
            <v-btn v-if="best_guess_amount!==1234" text  block class="mx-auto" dark  style="text-transform: none;border-radius:8px;">Bäst gissat<i class="glow22" style="margin-right:4px;margin-left:4px;background: white;color:#b01e28;border-radius: 4px;font-size:16px;padding:4px;">{{ best_guess_name }}</i> </v-btn>

          </v-card-actions>
        </v-card>
      </v-slide-y-transition>













    </v-card>
  </v-fab-transition>


</template>

<script>
export default {
  name: "Spons24",
  data() {
    return {
      guess_text:true,
      active:false,
      stage:0,
      random_guess:100,
      glow_index:0,
      code:"STREAM50",
      num_votes:0,
      streamer_name:"",
      best_guess_amount:1234,
      best_guess_name:"",
      to_show:{
        price:"",
        desc:"",
        name:"",
        image:""
      }



    }
  },
  mounted:function(){
    let self=this;
    setInterval(function(){
      self.random_guess=Math.round(Math.random()*1000)+259;
      self.guess_text=!self.guess_text;
    },3000);
    setInterval(function(){
      self.glow_index+=1;
      if(self.glow_index>self.code.length*3){
        self.glow_index=0
      }
    },100);
    let u=this.$route.query.u;
    this.streamer_name=u;
    if(this.streamer_name.charAt(this.streamer_name.length-1).toLowerCase()!=="s" && this.streamer_name.charAt(this.streamer_name.length-1).toLowerCase()!=="x"){
      this.streamer_name=this.streamer_name+"s";
    }


    this.$socket.emit('spons_listen_24',u);
    //this.generate_fake_votes();











  },

  computed: {


  },

  sockets: {

    on_vote:function(data){
      this.vote({name:data.name,vote:data.vote})
    },


    show_24_test:function(data){
      this.to_show=data;
      console.log(data);
      this.active=true;
      let self=this;

      setTimeout(function(){
        self.stage=1;
      },500)
      setTimeout(function(){
        self.stage=2;
        self.$socket.emit('bye_spons_24',self.num_votes);
        self.active=false;
        self.best_guess_amount=1234;
      },5000)




    },

    show_24:function(data){
      this.to_show=data;
      console.log(data);
      this.active=true;
      let self=this;

      setTimeout(function(){
        self.stage=1;
      },4000)
      setTimeout(function(){
        self.stage=2;
      },34000)
      setTimeout(function(){
        self.stage=0;
      },42000)
      setTimeout(function(){
        self.active=false;
        self.best_guess_amount=1234;
        self.$socket.emit('bye_spons_24',self.num_votes);
        self.num_votes=0;


      },45000)


    }

  },
  watch:{
    /*stage:function(){
      if(this.stage===1){
        this.generate_fake_votes();
      }
    }*/
  },
  methods:{

    vote:function(vote_data){
      console.log(vote_data);
      vote_data.vote=vote_data.vote.substring(1);

      let parsed_integer=parseInt(vote_data.vote);
      if(!isNaN(parsed_integer)){
        this.num_votes+=1;
        let element=document.createElement("div");


        element.innerHTML=`<span id="${vote_data.name}" class="v-chip theme--dark v-size--default red fade_left2" style="font-size:20px;background:#b01e28 !important;position:absolute;top:${Math.random()*300}px;left:${Math.random()*300}px;"><span class="v-chip__content">${vote_data.name}</span>:<span style="border-radius:8px;margin-left:12px;background:white;color:black;padding:2px;" class="v-chip__content"><b>${vote_data.vote} kr?</b></span></span>`
        document.getElementById("add_names").appendChild(element.firstChild);
        setTimeout(function(){
          document.getElementById("add_names").removeChild(document.getElementById(vote_data.name));
        },2.4*1000)
        if(Math.abs(parsed_integer-this.to_show.price)<this.best_guess_amount){
          this.best_guess_amount=parsed_integer;
          this.best_guess_name=vote_data.name;
        }
      }


    },

    generate_fake_votes:function(){
      let fake_names=[
        "2cuteilla",
        "Actuallynner",
        "Americast",
        "AmyKrool",
        "Artuggle",
        "Asedayal",
        "Barqualin",
        "Bazartip",
        "Blondeange",
        "Boardfi",
        "Boardintech",
        "Calcite",
        "Candyes",
        "Cattapp",
        "ChickEssence",
        "Comfylk",
        "Confire",
        "Coniervo",
        "Contreelo",
        "Cottonor",
        "Cyberlo",
        "Desightit",
        "Dictatorma",
        "DiddyParis",
        "Disseri",
        "Exterolo",
        "Fabrium",
        "Fareo",
        "FelineFaith",
        "Flexisys",
        "FluentGrabs",
        "Fraserstru",
        "FullyWet",
        "GazetteExclusive",
        "Givelz",
        "GrimSun",
        "GrimWitch",
        "Gurlyco",
        "HeadDev",
        "HeheMoto",
        "HeheRob",
        "Hipbb",
        "Huningst",
        "InfernoKix",
        "Integar",
        "Islandella",
        "JimMj",
        "JoFinest",
        "KenkaMega",
        "Laoandr",
        "LeonHead",
        "Listin",
        "Losimuni",
        "Lummobe",
        "Mcanardua",
        "Mcel",
        "Midnighter",
        "MinyTinnys",
        "Mohawkey",
        "NessNaybor",
        "NoticeSaiyan",
        "NycBleak",
        "Papass",
        "Pellinkie",
        "PerfectHippo",
        "Persdant",
        "Phiard",
        "PiraAsta",
        "Racer2cool",
        "RadioThesoy",
        "Relysi",
        "RocketSister",
        "Ryothus",
        "Sablinkak",
        "Sageolag",
        "Sanlc",
        "Scirraybo",
        "SelfCuddly",
        "Senaouder",
        "SereneKeepup",
        "SkierSnoop",
        "Sonflina",
        "Spiceelli",
        "Spicernin",
        "Sublega",
        "TalentCharms",
        "TalesStylish",
        "TaruRocker",
        "Theevilla",
        "TigerMusic",
        "ToyFlavored",
        "TrendyShoes",
        "TrustQuayle",
        "Ttiendos",
        "Twiter",
        "Tyob",
        "V2co",
        "Vamim",
        "Venabba",
        "Verterma"
      ];
      let name=fake_names[Math.floor(Math.random()*fake_names.length)]
      var vote0 =Math.round(Math.random()*1000);
      this.vote({name:name,vote:vote0});
      let self=this;
      setTimeout(function(){
        if(self.stage===1){
          self.generate_fake_votes();
        }
      },750+(Math.random()*500))
    },
  }
}
</script>

<style>
@font-face {
  font-family: "DIN";
  src: url(https://hihat.io/api/images/DIN_CondensedBold.ttf) format("truetype");
}

.shadowed{
  color: rgb(163,163,163);
}
iframe{
  width:100% !important;
  height:100% !important;
}

@keyframes MOVE-BG {

  from {
    -webkit-transform: translateX(-200px);
    -moz-transform: translateX(-200px);
    -ms-transform: translateX(-200px);
    -o-transform: translateX(-200px);
    transform: translateX(-200px);

  }
  to {

    -webkit-transform: translateX(-350px);
    -moz-transform: translateX(-350px);
    -ms-transform: translateX(-350px);
    -o-transform: translateX(-350px);
    transform: translateX(-350px);

  }
}
.move_bg{
  animation-name: MOVE-BG;
  animation-duration: 30s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: 1;
  -webkit-animation-fill-mode: forwards;
}

.hidden {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s 2s, opacity 2s linear;
}
.visible {
  visibility: visible;
  opacity: 1;
}

.shake_me{
  animation: recolor 0.3s infinite;
}

.fade_left2{
  animation: fade-left2 2.5s;
  animation-timing-function: ease-in;
}

@keyframes fade-left2 {
  0% { transform:  translate(0, 0) rotate(10deg) scale(0);opacity: 0.0; }
  5% { transform:  translate(0, 0) rotate(0deg) scale(1);opacity: 1.0; }

  100% { transform:  translate(0, -200px) rotate(0deg);opacity:0; }

}

.glow_letter{
  -webkit-box-shadow:0px 0px 10px 10px rgba(148, 69, 69, 0.3);
  -moz-box-shadow: 0px 0px 10px 10px rgba(162, 112, 112, 0.3);
  box-shadow: 0px 0px 10px 10px rgba(218, 182, 182, 0.3);
  transform:scale(1.1) rotate(10deg);
}





@keyframes shake {
  0% { transform: translate(1px, 1px) rotate(0deg); }
  10% { transform: translate(-1px, -2px) rotate(-1deg); }
  20% { transform: translate(-3px, 0px) rotate(1deg); }
  30% { transform: translate(3px, 2px) rotate(0deg); }
  40% { transform: translate(1px, -1px) rotate(1deg); }
  50% { transform: translate(-1px, 2px) rotate(-1deg); }
  60% { transform: translate(-3px, 1px) rotate(0deg); }
  70% { transform: translate(3px, 1px) rotate(-1deg); }
  80% { transform: translate(-1px, -1px) rotate(1deg); }
  90% { transform: translate(1px, 2px) rotate(0deg); }
  100% { transform: translate(1px, -2px) rotate(-1deg); }
}

@keyframes zoom {
  0% { : scale(1,1); }

  50% { transform: scale(1,1.4);}

  100% { transform: scale(1,1); }
}

@keyframes recolor {
  0% { background: rgba(0, 0, 0, 0.0); }

  50% { background: rgba(45, 83, 229, 0.1);}

  100% { background: rgba(0, 0, 0, 0.0);  }
}

.glow22{
  -webkit-filter: drop-shadow(3px 3px 3px #cd9eff);
  animation:glowy22 2s infinite;
}

@keyframes glowy22 {
  0% { -webkit-filter: drop-shadow(0px 0px 3px #ffffff); }
  50% { -webkit-filter: drop-shadow(0px 15px 9px #ffffff);}
  100% { -webkit-filter: drop-shadow(0px 0px 3px #ffffff); }


}

.promo_code{
  background: #0000003b;
  width: 36px;
  font-size: 20px;
  margin-right:3px;
  margin-left:3px;
  text-align: center !important;
}


</style>
